export const TASK_NAME_MAX_WIDTH = 240;
